import {
  orangeShades,
  primaryColors,
  whiteShades
} from '@assets/styles/helpers/colors.styles'

export const tabsStyles = {
  '.MuiTabs-scroller.MuiTabs-fixed': {
    overflowX: 'scroll !important',
    height: 'fit-content',
    msOverflowStyle: 'none',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
      display: 'none'
    }
  },
  '.MuiTabs-flexContainer': {
    gap: '1rem'
  },
  '&.MuiTabs-root': {
    minWidth: 0,
    minHeight: 0
  },
  '.MuiTabs-indicator': {
    backgroundColor: primaryColors.white
  }
}

export const tabStyles = {
  color: whiteShades.shade1,
  fontWeight: 400,
  fontFamily: 'helvetica-neue-lt-pro, "Open Sans", sans-serif',
  textTransform: 'capitalize',
  padding: '0 0 0.375rem 0',

  '&:focus': {
    outline: 'none'
  },
  '&.Mui-selected': {
    color: primaryColors.white
  },
  '&.MuiButtonBase-root': {
    minWidth: 0,
    minHeight: 0
  }
}

export const tabErrorStyles = {
  color: primaryColors.orange,
  '&.Mui-selected': {
    color: orangeShades.shade1
  }
}
